import React from 'react';
import { PricingCards } from './PricingCards';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 md:py-32 px-4 bg-dark-card/50 border-t border-dark-border relative overflow-hidden" data-id="element-86">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-87" />

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-88">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-89">
          Descubrí el legado de una civilización que sigue fascinando al mundo
          después de más de 5.000 años.
        </h2>

        <PricingCards data-id="element-90" />

        <div className="mt-16 mb-12" data-id="element-91">
          <p className="text-xl md:text-2xl font-heading font-bold text-gold-light italic max-w-4xl mx-auto" data-id="element-92">
            "La historia no solo se estudia. Se vive, se descubre y se recuerda.
            Egipto Legendario es una invitación a recorrer una de las
            civilizaciones más fascinantes de todos los tiempos."
          </p>
        </div>

        <div className="mt-8 flex flex-wrap justify-center items-center gap-6 md:gap-8 text-sm md:text-base text-gray-400" data-id="element-93">
          <div className="flex items-center gap-2" data-id="element-94">
            <Lock className="w-5 h-5 text-gold" data-id="element-95" />
            <span data-id="element-96">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-97">
            <Zap className="w-5 h-5 text-gold" data-id="element-98" />
            <span data-id="element-99">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-100">
            <Shield className="w-5 h-5 text-gold" data-id="element-101" />
            <span data-id="element-102">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}